import React from "react";
import { useTheme } from "next-themes";
import { Monitor, Moon, Sun } from "lucide-react";

const OPTIONS = [
  { id: "light", label: "Light", icon: Sun },
  { id: "dark", label: "Dark", icon: Moon },
  { id: "system", label: "System", icon: Monitor },
];

/**
 * Light / dark / follow-the-OS. A segmented control rather than a single
 * flip, because "system" is a choice of its own: someone who picks it wants
 * the app to change when their OS does at sunset, which a two-way toggle
 * cannot express.
 */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div role="radiogroup" aria-label="Colour theme" data-testid="theme-toggle"
         className="flex items-center gap-0.5 p-0.5 rounded-md"
         style={{ background: "var(--surface)", border: "1px solid var(--border)" }}>
      {OPTIONS.map(({ id, label, icon: Icon }) => {
        const active = theme === id;
        return (
          <button key={id} type="button" role="radio" aria-checked={active} aria-label={label} title={label}
                  data-testid={`theme-opt-${id}`}
                  onClick={() => setTheme(id)}
                  className={`p-1.5 rounded ${active ? "" : "hover-wash"}`}
                  style={active
                    ? { background: "var(--surface-2)", color: "var(--text)" }
                    : { color: "var(--text-muted)" }}>
            <Icon size={13} strokeWidth={2} />
          </button>
        );
      })}
    </div>
  );
}
